import { useEffect, useState, useCallback } from "react";
import { fetchProducts } from "./lib/api";

/**
 * Fetches products and keeps them fresh:
 *  - initial load
 *  - on window focus / tab visible (so dashboard changes appear without manual refresh)
 *  - manual reload()
 */
export function useProducts() {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);

  const reload = useCallback(() => {
    return fetchProducts()
      .then((data) => {
        setProducts(data);
        setError(null);
      })
      .catch((e) => {
        console.error(e);
        setError("Impossibile caricare la collezione.");
      });
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") reload();
    };
    const onFocus = () => reload();
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onFocus);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onFocus);
    };
  }, [reload]);

  return { products, error, reload };
}
